import gql from 'graphql-tag';

export default gql`
    mutation SaveCrew($input: SaveCrewInput) {
        saveCrew(input: $input) {
            errors
        }
    }
`;
